import tool from '@/utils/tool';

function getDaysToCurYear() {
  const curYear = new Date().getFullYear();
  return tool.getDaysToNow(
    `${curYear}-1-1`,
  );
}

export default {
  // 行业饼图颜色配置
  industryColor: [
    '#3C6DF7',
    '#4D8EFF',
    '#7ABDFF',
    '#7AD8FF',
    '#8149F7',
    '#926EFD',
    '#B099FF',
    '#AF5EBC',
    '#C77CD3',
    '#DFA2E9',
    '#C33F5D',
    '#CB5571',
    '#FF89A7',
    '#EA7690',
    '#F096AB',
    '#FF6933',
    '#FF8255',
    '#FE9E7A',
    '#FE9803',
    '#FFB515',
    '#FFCD5A',
    '#FFDD3E',
    '#BF6735',
    '#CBBAFF',
    '#EEA687',
  ],

  // 基金图表tab列表
  fundChartTabList: {
    currency: [{ // 货币基金
      tabName: '万元收益',
      tabValue: 'profitOf10000',
      chartType: 'line',
    }, {
      tabName: '七日年化',
      tabValue: 'annualizationOf7D',
      chartType: 'line',
    }],
    ETF: [{
      tabName: '分时',
      tabValue: 'timeSharing',
      chartType: 'timeSharing',
    }, {
      tabName: '日K',
      tabValue: 'KOfDay',
      chartType: 'kLine',
    }, {
      tabName: '周K',
      tabValue: 'KOfWeek',
      chartType: 'kLine',
    }, {
      tabName: '月K',
      tabValue: 'KOfMonth',
      chartType: 'kLine',
    }, {
      tabName: '净值',
      tabValue: 'perNetValue',
      chartType: 'line',
    }],
    gold: [{ // 黄金
      tabName: '累计收益',
      tabValue: 'accProfit',
      chartType: 'line',
    }, {
      tabName: '单位净值',
      tabValue: 'perNetValue',
      chartType: 'line',
    }, {
      tabName: '累计净值',
      tabValue: 'accNetValue',
      chartType: 'line',
    }, {
      tabName: '金价走势',
      tabValue: 'trendOfGold',
      chartType: 'line',
    }],
    indexFund: [{ // 指数，h5都不展示净值估算：产品 张文晓
      tabName: '累计收益',
      tabValue: 'accProfit',
      chartType: 'line',
    }, {
      tabName: '单位净值',
      tabValue: 'perNetValue',
      chartType: 'line',
    }, {
      tabName: '累计净值',
      tabValue: 'accNetValue',
      chartType: 'line',
    }],
  },

  // 基金图表时间范围选择 ['y', '3y', '6y', 'n', '3n', '5n', 'jn', 'ln']
  chartPeriodList: [{
    value: 'y',
    label: '近1月',
    unableLabel: '不满1月',
    dayCount: 30,
  }, {
    value: '3y',
    label: '近3月',
    unableLabel: '不满3月',
    dayCount: 90,
  }, {
    value: '6y',
    label: '近6月',
    unableLabel: '不满6月',
    dayCount: 180,
  }, {
    value: 'n',
    label: '近1年',
    unableLabel: '不满1年',
    dayCount: 365,
  }, {
    value: '3n',
    label: '近3年',
    unableLabel: '不满3年',
    dayCount: 365 * 3,
  }, {
    value: '5n',
    label: '近5年',
    unableLabel: '不满5年',
    dayCount: 365 * 5,
  }, {
    value: 'jn',
    label: '今年来',
    unableLabel: (estDate) => `成立来(${estDate}成立)`,
    dayCount: getDaysToCurYear(),
  }, {
    value: 'ln',
    unableLabel: '不满1年',
    label: '成立来',
    dayCount: 365,
  }],

  // 市场行情tab列表
  quotationTabList: {
    currency: [{
      tabName: '阶段涨幅',
      value: 'stageRise',
    }, {
      tabName: '历史7日年化',
      value: 'annualizationOf7D',
    }],
    ETF: [{
      tabName: '阶段涨幅',
      value: 'stageRise',
      icon: 'https://j5.dfcfw.com/sc/image/202110/20211009012345.png',
    }, {
      tabName: '历史净值',
      value: 'historyNetValue',
    }],
    default: [{
      tabName: '阶段涨幅',
      value: 'stageRise',
    }, {
      tabName: '历史净值',
      value: 'historyNetValue',
    }, {
      tabName: '定投收益',
      value: 'fixedProfit',
    }],
  },

  // 市场行情列表表头配置
  quotationListHeader: {
    stageRise: [ // 阶段涨幅
      {
        name: '时间',
        style: {
          flex: 2,
          justifyContent: 'flex-start',
        },
      },
      {
        name: '涨跌幅',
        style: {
          flex: 3,
          justifyContent: 'center',
        },
      },
      {
        name: '同类平均',
        style: {
          flex: 3,
          justifyContent: 'center',
        },
        showTip: true,
        tipModalType: 'type-point',
      },
      {
        name: '同类排行',
        style: {
          flex: 3,
          justifyContent: 'flex-end',
        },
        showTip: true,
        tipModalType: 'type-rank',
      },
    ],
    historyNetValue: [ // 历史净值
      {
        key: 'date',
        name: '日期',
        style: {
          flex: 2,
          textAlign: 'left',
          justifyContent: 'flex-start',
        },
      },
      {
        key: 'netAssetValue',
        name: '单位净值',
        style: {
          flex: 3,
          textAlign: 'center',
          justifyContent: 'center',
        },

      },
      {
        key: 'accumulatedNet',
        name: '累计净值',
        style: {
          flex: 3,
          textAlign: 'center',
          justifyContent: 'center',
        },
      },
      {
        key: 'rise',
        name: '日涨幅',
        style: {
          flex: 3,
          textAlign: 'right',
          justifyContent: 'flex-end',
        },
        showTip: true,
        tipModalType: 'day-rise',
      },
    ],
    fixedProfit: [], // 定投收益-需特殊处理
    annualizationOf7D: [ // 历史7日年化
      {
        key: 'date',
        name: '日期',
        style: {
          flex: 2,
          textAlign: 'left',
          justifyContent: 'flex-start',
        },
      },
      {
        key: 'netAssetValue',
        name: '万元收益',
        style: {
          flex: 3,
          textAlign: 'center',
          justifyContent: 'center',
        },
      },
      {
        key: 'rise',
        name: '七日年化',
        style: {
          flex: 3,
          textAlign: 'right',
          justifyContent: 'flex-end',
        },
      },
    ],
  },

  // 基金持仓tab列表
  fundHoldTabList: {
    currency: [{ // 货币
      name: '资产',
      value: 'asset',
      chartType: 'fund-ring-chart',
    }, {
      name: '规模',
      value: 'scale',
      chartType: 'scale-bar-chart',
    }],
    fof: [{ // FOF
      name: '资产',
      value: 'asset',
      chartType: 'fund-ring-chart',
    }, {
      name: '分类',
      value: 'classify',
      chartType: 'fund-ring-chart',
    }, {
      name: '规模',
      value: 'scale',
      chartType: 'scale-bar-chart',
    }],
    bond: [{ // 债券
      name: '资产',
      value: 'asset',
      chartType: 'fund-ring-chart',
    }, {
      name: '券种',
      value: 'bondType',
      chartType: 'fund-ring-chart',
    }, {
      name: '规模',
      value: 'scale',
      chartType: 'scale-bar-chart',
    }],
    default: [{ // 默认
      name: '资产',
      value: 'asset',
      chartType: 'fund-ring-chart',
    }, {
      name: '行业',
      value: 'industry',
      chartType: 'fund-ring-chart',
    }, {
      name: '规模',
      value: 'scale',
      chartType: 'scale-bar-chart',
    }],
  },

  // 重仓股票列表表头配置
  heavyStockListHeader: [{
    name: '股票名称',
    key: 'stockName',
    style: {
      flex: 5,
      justifyContent: 'flex-start',
    },
  },
  {
    name: '价格',
    key: 'stockPrice',
    style: {
      flex: 4,
      justifyContent: 'center',
    },
  },
  {
    name: '持仓占比',
    key: 'holdProportion',
    style: {
      flex: 3,
      justifyContent: 'center',
    },
  },
  {
    name: '较上期',
    key: 'lastTime',
    style: {
      flex: 3,
      justifyContent: 'flex-end',
    },
  }],
  // 货币基金持仓列表
  currencyHoldHeaderList: [
    {
      name: '平均剩余期限',
      key: 'avgMaturity',
      style: {
        flex: 3,
        justifyContent: 'flex-start',
      },
    },
    {
      name: '资产占比',
      key: 'assetProportion',
      style: {
        flex: 2,
        justifyContent: 'center',
      },
    },
    {
      name: '负债占比',
      key: 'debtRatio',
      style: {
        flex: 2,
        justifyContent: 'flex-end',
      },
    },
  ],
  // 重仓基金列表表头配置
  heavyFundListHeader: [
    {
      name: '基金名称',
      key: 'fundName',
      style: {
        flex: 3,
        justifyContent: 'flex-start',
      },
    },
    {
      name: '持仓占比',
      key: 'holdRatio',
      style: {
        flex: 2,
        justifyContent: 'center',
      },
    },
    {
      name: '较上期',
      key: 'lastTime',
      style: {
        flex: 2,
        justifyContent: 'flex-end',
      },
    },
  ],
  // 重仓债券列表表头配置
  heavyBondListHeader: [
    {
      name: '债券名称',
      key: 'bondName',
      style: {
        flex: 5,
        justifyContent: 'flex-start',
      },
    },
    {
      name: '价格',
      key: 'bondPrice',
      style: {
        flex: 4,
        justifyContent: 'center',
      },
    },
    {
      name: '持仓占比',
      key: 'bondRatio',
      style: {
        flex: 3,
        justifyContent: 'center',
      },
    },
    {
      name: '较上期',
      key: 'lastBond',
      style: {
        flex: 3,
        justifyContent: 'flex-end',
      },
    },
  ],
  // 特殊数据提示内容
  featureDataAlertList: [
    {
      title: '数据排行说明',
      showMore: true,
      content: '特色数据均采用最新同类分类排名，若本基金属于混合型-偏股基金，则波动率只看本基金在混合型-偏股基金中的波动率大小程度。',
    },
    {
      title: '夏普比率',
      showMore: false,
      content: '表示每承受一单位风险，预期可以拿到多少超额收益。\n指标越大越好。夏普比率越大则基金性价比越高。',
      subContent: '*当基金收益率低于无风险利率(存款利率)时，夏普比率为负，此时该数据的参考意义有限。',
    },
    {
      title: '波动率',
      showMore: false,
      content: '表示收益率变化程度的指标，更直观地表述就是风险。\n指标越小越好。波动率越大则风险也越高。',
    },
    {
      title: '最大回撤',
      showMore: false,
      content: '表示基金净值从最高到最低的下降幅度。指标越小越好。\n最大回撤越大则风险控制能力越差。',
    },
    {
      title: '跟踪误差（年化）',
      showMore: false,
      content: '表示指数基金与其跟踪指数的偏离程度。指标越小越好，跟踪误差越小偏离误差越小。（此处展示指标为年化值）',
    },
  ],
};
